'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _typeof = require('./../../external/@babel/runtime/helpers/esm/typeof.js');
var toConsumableArray = require('./../../external/@babel/runtime/helpers/esm/toConsumableArray.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
var useMobileBool = require('../../utilities/hooks/useMobileBool.js');
var index$1 = require('../../utilities/GatsbyLink/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var BreadCrumbs = function BreadCrumbs(_ref) {
  var className = _ref.className,
    customCrumbs = _ref.customCrumbs,
    externalCrumbs = _ref.externalCrumbs,
    location = _ref.location,
    homeName = _ref.homeName,
    homeRef = _ref.homeRef,
    hidePath = _ref.hidePath;
  var breadcrumbsClasses = index.default('breadcrumbs', className);
  var unslugify = function unslugify(string) {
    // .replaceAll() breaks tests because it isn't supported in node
    var search = '-';
    var replacer = new RegExp(search, 'g');
    return string.replace(replacer, ' ');
  };
  var createCrumb = function createCrumb(name, pathname) {
    var link = pathname.substr(0, pathname.indexOf(name)) + name + '/';
    var displayName = unslugify(name);
    return /*#__PURE__*/React__default.default.createElement(React.Fragment, {
      key: name
    }, /*#__PURE__*/React__default.default.createElement(index$1.default, {
      href: link,
      className: "breadcrumbs-name"
    }, displayName), /*#__PURE__*/React__default.default.createElement("div", {
      className: "breadcrumbs-divider"
    }, "/"));
  };
  var filterHidden = function filterHidden(hide, crumb) {
    return hide !== null ? crumb.filter(function (n) {
      return n !== hide;
    }) : crumb;
  };
  var renderCrumbs = function renderCrumbs() {
    var pathname = location.pathname;
    var isMobile = useMobileBool.useMobileBool();
    var crumbNames = pathname.split('/').filter(function (i) {
      return i;
    });
    if (isMobile && crumbNames.length > 2) {
      crumbNames = [crumbNames.shift()];
    } else {
      isMobile && crumbNames.pop();
    }
    var altCrumb = filterHidden(hidePath, crumbNames);
    return altCrumb.map(function (name) {
      return createCrumb(name, pathname);
    });
  };
  var renderCustomCrumbs = function renderCustomCrumbs() {
    var crumbs = toConsumableArray.default(customCrumbs);
    var isMobile = useMobileBool.useMobileBool();
    if (isMobile && crumbs.length > 2) {
      crumbs = [crumbs.shift()];
    } else {
      isMobile && crumbs.pop();
    }
    return crumbs.map(function (_ref2) {
      var name = _ref2.name,
        link = _ref2.link;
      return /*#__PURE__*/React__default.default.createElement(React.Fragment, {
        key: name
      }, /*#__PURE__*/React__default.default.createElement(index$1.default, {
        href: link,
        className: "breadcrumbs-name"
      }, unslugify(name)), /*#__PURE__*/React__default.default.createElement("div", {
        className: "breadcrumbs-divider"
      }, "/"));
    });
  };
  var renderExternalCrumbs = function renderExternalCrumbs() {
    if (!externalCrumbs || externalCrumbs.length === 0) {
      return null;
    }
    return externalCrumbs.map(function (crumb, index) {
      return /*#__PURE__*/React__default.default.createElement(React.Fragment, {
        key: "ext-crumb-".concat(crumb.name, "-").concat(index)
      }, /*#__PURE__*/React__default.default.createElement(index$1.default, {
        href: crumb.link,
        className: "breadcrumbs-name"
      }, crumb.name), /*#__PURE__*/React__default.default.createElement("div", {
        className: "breadcrumbs-divider"
      }, "/"));
    });
  };
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: breadcrumbsClasses,
    "data-testid": "lanl-breadcrumbs"
  }, renderExternalCrumbs(), /*#__PURE__*/React__default.default.createElement(index$1.default, {
    href: homeRef,
    className: "breadcrumbs-name"
  }, homeName), /*#__PURE__*/React__default.default.createElement("div", {
    className: "breadcrumbs-divider"
  }, "/"), location ? renderCrumbs() : renderCustomCrumbs());
};
BreadCrumbs.defaultProps = {
  homeRef: '/'
};
BreadCrumbs.propTypes = {
  className: PropTypes__default.default.string,
  customCrumbs: PropTypes__default.default.arrayOf(PropTypes__default.default.shape({
    link: PropTypes__default.default.string.isRequired,
    name: PropTypes__default.default.string.isRequired
  })),
  externalCrumbs: PropTypes__default.default.arrayOf(PropTypes__default.default.shape({
    link: PropTypes__default.default.string.isRequired,
    name: PropTypes__default.default.string.isRequired
  })),
  hidePath: PropTypes__default.default.string,
  homeName: PropTypes__default.default.string,
  homeRef: PropTypes__default.default.string,
  location: function location(props, propName, componentName) {
    if (props['customCrumbs'] && props[propName]) {
      return new Error("'".concat(componentName, "' cannot have both location prop and customCrumbs prop"));
    }
    if (props[propName] && _typeof.default(props[propName]) !== 'object') {
      return new Error("Invalid prop location of type '".concat(_typeof.default(props[propName]), "' supplied to '").concat(componentName, "', expected 'object' "));
    }
  }
};

exports.BreadCrumbs = BreadCrumbs;
exports.default = BreadCrumbs;
//# sourceMappingURL=BreadCrumbs.js.map
